export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * Takes a full name string and returns an array of strings, w/ maximum length 2, where
 * first token is the first token and second token is the concatenation of all remaining
 * tokens. If the array has only 1 token, an array of length 1 is returned; if the string
 * contains no valid tokens, returns null.
 */
export function tokenizeFullName(fullName: string | undefined): Array<string> | null {
    if (fullName === undefined) {
        return null;
    }

    let tokenized = fullName.split(' ');

    if (!tokenized) {
        return null;
    }

    // Remove empty tokens
    tokenized = tokenized.filter((t) => !!t);

    if (tokenized.length === 0) {
        return null;
    }

    if (tokenized.length < 2) {
        return tokenized;
    }

    let fname = tokenized[0];
    let lname = tokenized.slice(1).join(' ');

    return [fname, lname];
}
